/**
 * 正式網址的編碼工具。
 *
 * 舊站 slug 多為原始中文（例：從電影看板到建築設計-中美館「搖擺阿哥哥」走）。
 * 未編碼的中文網址貼到 LINE / 聊天軟體時，非 ASCII 部分不會被自動變成連結，
 * 而手機瀏覽器「分享」出去的則是百分比編碼後的網址 → 兩邊字串不同。
 * 因此「複製」一律複製百分比編碼後的網址（與手機瀏覽器分享的一致），畫面上可顯示解碼後的可讀版本。
 */

/** decodeURIComponent，遇到不合法的 % 序列時原樣返回（避免拋錯）。 */
function safeDecodeComponent(s: string): string {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}

/** 編碼單一路徑片段：先解碼（避免二次編碼）再 encodeURI，並補編 ? # /（encodeURI 不會編）。 */
export function encodePathSegment(segment: string): string {
  return encodeURI(safeDecodeComponent(segment)).replace(
    /[?#/]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
  );
}

/** 組出前台正式網址（百分比編碼，可直接分享/複製）。 */
export function buildPublicUrl(base: string, slug: string): string {
  const path = slug
    .replace(/^\/+/, '')
    .split('/')
    .map(encodePathSegment)
    .join('/');
  return `${base.replace(/\/+$/, '')}/${path}`;
}

/** 顯示用：把編碼過的網址解回人眼可讀的中文（保留 %3F 等保留字元的編碼）。 */
export function displayUrl(url: string): string {
  try {
    return decodeURI(url);
  } catch {
    return url;
  }
}
